import React from "react";
import { AppIconsAdd } from "../../../AppIcons";
import { StyledAddBasketButton } from "./AddBasketButton.style";
import { Basket } from "../../../../../explorer/types/Basket/Basket";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";

type Props = {
    setLoading: (loading: boolean) => void;
    setBasketActionResultSnackbarState: (_p: any) => void;
    setCreateDialogOpen: (_p: boolean) => void;
};

export function AddBasketButton(props: Readonly<Props>) {
    // ---------------
    // Basket create
    // ---------------
   const { t } = useTranslation();
   
   
   const [baskets, setBaskets] = useReduxState<Basket[]>(
       reduxStoreConfig.basketBaskets
   );
    
    const handleCreateBasket = () => {
        props.setCreateDialogOpen(true);
    };
   

    return (

        <React.Fragment>
            <StyledAddBasketButton
                color="primary"
                aria-label="add"
                onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    handleCreateBasket();
                    return false;
                }}
            >
                <AppIconsAdd />
            </StyledAddBasketButton>
        </React.Fragment>
    );
}